import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

import Logo from "../../images/logo1.png";
import layout from "../../css/landing.module.css";
import styles from "../../css/tithe.module.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faHouse,
  faArrowRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";

function Payfruitfaith() {
  const { church_id } = useParams();
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [successModal, setSuccessModal] = useState(false);

  const today = new Date();
  const itemdate = today.toLocaleDateString("en-GB");

  // ===== FETCH USER =====
  useEffect(() => {
    axios
      .get(`https://appserver.cemkharistemple.com/paytithefaith/${church_id}`)
      .then((res) => {
        setUser(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, [church_id]);

  // ===== FORM STATE =====
  const [formData, setFormData] = useState({
    church_id,
    amount: "",
    date_entry: itemdate,
    date: "",
    month: "",
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  // ===== SAVE FIRST FRUIT =====
  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await axios.post(
        "https://appserver.cemkharistemple.com/savefirstfruitfaith",
        { value: formData }
      );

      if (res.data.message === "Success") {
        setSuccessModal(true);
      }
    } catch (err) {
      console.error(err);
    }

    setLoading(false);
  };

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  if (loading) return <div>Loading...</div>;
  if (!user) return <div>User not found</div>;

  const fullName = `${user.first_name} ${user.last_name}`;

  return (
    <div className={layout.container}>

      {/* ===== HEADER ===== */}
      <header className={layout.header}>
        <div className={layout.pageTitleWrap}>
          <h1 className={layout.pageTitle}>Financial Records</h1>
          <p className={layout.pageSubtitle}>First Fruit Offering</p>
        </div>

        <div className={layout.headerRight}>
          <div className={layout.userChip}>
            <FontAwesomeIcon icon={faUser} />
            <span>Admin</span>
          </div>

          <button
            className={layout.iconBtn}
            onClick={() => navigate("/payfirstfruitfaith")}
          >
            <FontAwesomeIcon icon={faHouse} />
          </button>

          <button
            className={`${layout.iconBtn} ${layout.dangerBtn}`}
            onClick={handleLogout}
          >
            <FontAwesomeIcon icon={faArrowRightFromBracket} />
          </button>
        </div>
      </header>

      {/* ===== SIDEBAR ===== */}
      <aside className={layout.sidebar}>
        <div className={layout.sideTop}>
          <img src={Logo} className={layout.logoImg} alt="" />
          <div>Faith Admin</div>
        </div>
      </aside>

      {/* ===== MAIN ===== */}
      <main className={layout.main}>
        <div className={styles.outerwrapper}>

          <div className={styles.memberHeader}>
            <div className={styles.memberId}>{user.church_id}</div>
            <div className={styles.memberName}>{fullName}</div>
          </div>

          <form onSubmit={handleSave} className={styles.allitems}>
            <h3>Pay First Fruit</h3>

            <div className={styles.groupinfo}>
              <div className={styles.textpers}>
                <label>Amount</label>
                <input
                  name="amount"
                  onChange={handleChange}
                  required
                />
              </div>

              <div className={styles.textpers}>
                <label>Month</label>
                <select
                  name="month"
                  className={styles.dropdown}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Month</option>
                  {[
                    "January", "February", "March", "April",
                    "May", "June", "July", "August",
                    "September", "October", "November", "December"
                  ].map((m) => (
                    <option key={m} value={m}>{m}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className={styles.groupinfo}>
              <div className={styles.textpers}>
                <label>Date</label>
                <input
                  type="date"
                  name="date"
                  onChange={handleChange}
                  required
                />
              </div>

              <div className={styles.textpers}>
                <label>Date Entry</label>
                <input value={itemdate} disabled />
              </div>
            </div>

            <div className={styles.formbuttons}>
              <button type="submit" className={styles.submit_button}>
                Submit
              </button>

              <button
                type="button"
                className={styles.cancel_button}
                onClick={() => navigate("/payfirstfruitfaith")}
              >
                Cancel
              </button>
            </div>
          </form>

        </div>
      </main>

      {/* ===== SUCCESS MODAL ===== */}
      {successModal && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalBox}>
            <h3>First Fruit Recorded 🎉</h3>
            <p>Offering saved and confirmation SMS sent.</p>

            <button
              className={styles.submit_button}
              onClick={() => navigate("/payfirstfruitfaith")}
            >
              Back
            </button>
          </div>
        </div>
      )}

    </div>
  );
}

export default Payfruitfaith;